import { MockModuleController } from "controllers/MockModuleController";
import { FlexDashboardController } from "controllers/FlexDashboardController";
import { FlexController } from "controllers/FlexController";

// Order of controllers is important here
export const controllers = [MockModuleController, FlexDashboardController, FlexController];
